import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogAgentMessage_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';
import ActivityLogCommentBody from 'src/entities/ActivityLog/Helpers/ActivityLogCommentBody';
import ActivityLogContent from 'src/entities/ActivityLog/Helpers/ActivityLogContent';

import useIsAiTaskEnabled from 'src/hooks/useIsAiTaskEnabled';

interface Fragments {
  activityLog: ActivityLogAgentMessage_ActivityLogFragment;
}

type ActivityLogContentShape = {
  markdown?: string | null;
};

const ActivityLogAgentMessage: FCWithFragments<Fragments> = ({ activityLog }) => {
  const aiTaskEnabled = useIsAiTaskEnabled();
  if (!aiTaskEnabled) {
    return null;
  }

  const { details } = activityLog;
  // eslint-disable-next-line no-underscore-dangle
  const isAgentMessageDetails = details?.__typename === 'ActivityLogAgentMessageDetails';
  const message = isAgentMessageDetails ? details.message : '';
  const markdown = isAgentMessageDetails
    ? (details as typeof details & { content?: ActivityLogContentShape | null }).content?.markdown || message || null
    : null;

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.addedComment"
      actionLabelValues={{}}
    >
      {message ? (
        <ActivityLogContent
          fullWidth
          sx={{ borderRadius: '6px 12px 12px 12px', ml: 0 }}
          content={<ActivityLogCommentBody legacyText={message} markdown={markdown} />}
        />
      ) : null}
    </ActivityLogBase>
  );
};

ActivityLogAgentMessage.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogAgentMessage_activityLog on ActivityLog {
      id
      details {
        ... on ActivityLogAgentMessageDetails {
          __typename
          message
          content {
            markdown
            plaintext
            formatVersion
            editorStateJson
          }
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogAgentMessage;
